import growthAcquisitionExperiments from 'bundles/epic/clients/GrowthAcquisition';

export const isArkoseBotManagerForSignupEnabled = () =>
  growthAcquisitionExperiments.preview('enableArkoseBotManagerForSignup');

export const isInPasswordlessSignupVariant = () => growthAcquisitionExperiments.preview('passwordlessSignup');

export const generateImpressionForPasswordlessSignup = () => growthAcquisitionExperiments.get('passwordlessSignup');
